import React from 'react';
import { ICartItem } from '../../../../../../../Interfaces/componentTypes';
import { ITableReserveForm } from '../../../../../../../Interfaces/formValue-interfaces';
import { MainCart, Reserve } from '../../../../../../../Assets/Icons';
import styles from './cart.module.scss';

interface IProps {
  mainCart: [] | ICartItem[],
  isReserveForm: ITableReserveForm | null,
  onClick: () => void
};

const Cart: React.FC<IProps> = ({ onClick, mainCart, isReserveForm }) => {
  return (
    <div className={styles.container} onClick={onClick}>
      {
        mainCart.length > 0
        &&
        <p>{mainCart.length}</p>
      }
      <img src={isReserveForm ? Reserve : MainCart} alt='mainCart.svg' />
    </div>
  )
};

export default Cart
